import * as React from 'react';
const classNames = require('classnames');

interface Props {
	className?: string;
	children?: {};
}

const WorkflowFieldset: React.StatelessComponent<Props> = ({ className, children }) => {
	return (
		<div className={classNames('row', className)}>
			<div className="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
				<div className="form-fieldset content-set">{children}</div>
			</div>
		</div>
	);
};

export default WorkflowFieldset;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/forms/Fieldset.tsx